<template>
  <div>
    <VCard title="Email Template 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'app-global-template-mail',
  },  
})
</script>
